// Centralized Archive configuration.
// Adding a new archive year should only require adding one object here.

export const archives = [
  {
    year: '2024',
    label: 'WCHSS 2024',
    links: {
      main: '/wchss-2024',
      publication: '/wchss-2024/publication',
      gallery: '/wchss-2024/gallery',
    },
  },
  {
    year: '2022',
    label: 'WCHSS 2022',
    links: {
      main: 'https://wchss-2022.binawan.ac.id',
      publication: 'https://www.atlantis-press.com/proceedings/wchss-22/articles',
      gallery: '/gallery',
    },
  },
];
